/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module) {
	'use strict';

	var SearchPromoBox = Module.extend({
		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
		},

		// Mark us a search-dependent module
		initSearch: function() {},

		findElements: function() {
			this.data = this.$ctx.data();
			this.$content = this.$ctx.children('div:eq(0)');
			this.id = this.$content.attr('id');
		},

		getAdConfig: function() {
			// FIXME: Implement hiding when keymatches are present (if this.data.hideIfKeymatches)
			return {
				container: this.id,
				number: this.data.sitesearchNumberOfAds,
				width: 'auto',
				lines: this.data.sitesearchNumberOfLines,
				fontFamily: 'Trebuchet MS',
				fontSizeTitle: 15,
				fontSizeDescription: 13,
				fontSizeDomainLink: 13,
				colorTitleLink: '#' + this.data.sitesearchColorTitleLink,
				colorText: '#' + this.data.sitesearchColorLink,
				colorDomainLink: '#' + this.data.sitesearchColorDomainLink,
				colorBackground: '#' + this.data.sitesearchColorBackground,
				noTitleUnderline: true
			};
		}
	});

	Module.SearchPromoBox = SearchPromoBox;

})(window.Tc.Module);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPromoBox.js
// module id = 313
// module chunks = 0